import PropTypes from 'prop-types'
import { PureComponent } from 'react'
import { connect } from 'react-redux'
import { Button, Form, Message, Modal } from 'semantic-ui-react'

import { trackEvent } from 'global-utils/Analytics'

import { authAction, authResetPassword, authResetPasswordCanceled } from 'actions/AuthActions'

import './ResetPassword.css'

class ResetPassword extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      dirties: {},
      email: '',
      errors: {},
      totalDirties: 1,
      updating: false,
    }
    this.dirties = {}
    this.errors = {}
    this.updatingTimeout = null
  }

  componentDidUpdate(prevProps) {
    if (this.state.updating && prevProps.error !== this.props.error) {
      this.startUpdateTimeout()
    }
  }

  componentWillUnmount() {
    clearTimeout(this.updatingTimeout)
  }

  close = () => {
    this.props.authResetPasswordCanceled()
    this.props.onClose()
  }

  onChange = (field, event) => {
    const newState = { ...this.state }
    const value = (event.target.value || '').trim()
    let error = false
    const errorField = field

    switch (field) {
      case 'email': {
        const re =
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        error = !value || value.length <= 1 || !re.test(value)
        break
      }
      default: {
        break
      }
    }

    newState[field] = value
    this.dirties[field] = true

    if (error) {
      this.errors[errorField] = true
    } else {
      delete this.errors[errorField]
    }

    this.setState(newState)
  }

  onFormSubmit = (event) => {
    const { email } = this.state

    trackEvent('Authentication', 'Password Reset', 'Attempt')

    event.preventDefault()
    const hasErrors = Object.keys(this.errors).length
    const totalDirties = Object.keys(this.dirties).length

    if (!this.state.updating && !hasErrors && totalDirties === this.state.totalDirties) {
      this.setState({ updating: true }, () => this.props.authResetPassword(email, true))
    }
  }

  onLoginClick = (event) => {
    event.preventDefault()
    this.props.authAction('login')
  }

  onRegisterClick = (event) => {
    event.preventDefault()
    this.props.authAction('register')
  }

  startUpdateTimeout = () => {
    clearTimeout(this.updatingTimeout)
    this.updatingTimeout = setTimeout(() => this.setState({ updating: false }), 1000 * 7)
  }

  render() {
    const { error, open } = this.props
    const { updating } = this.state
    let errorMsg = null
    if (error) {
      const content = []
      Object.values(error?.response?.data?.[0] || {}).forEach((errorsMessages) => {
        content.push(...errorsMessages)
      })

      errorMsg = (
        <Message content={content.length > 0 ? content.map((msg) => <div key={msg}> - {msg}</div>) : error.msg} error />
      )
    }
    const hasErrors = Object.keys(this.errors).length > 0
    return (
      <Modal className="ModalResetPassword" closeIcon="close" onClose={this.close} open={open} size="small">
        <Modal.Header>Cambiar contraseña</Modal.Header>
        <Modal.Content>
          <Form key="mini" as="form" error={!!error || hasErrors} onSubmit={this.onFormSubmit} size="mini">
            <Form.Field
              autoComplete="email"
              control="input"
              error={!!this.errors.email}
              label="E-mail"
              onChange={(e) => this.onChange('email', e)}
              placeholder="E-mail"
              type="email"
            />
            <Button
              className={`ModalResetPassword__button ${updating ? 'loading disabled' : 'primary'} ${
                Object.keys(this.dirties).length === this.state.totalDirties ? '' : ' disabled'
              }`}
              type="submit"
            >
              Solicitar
            </Button>
            <div className="flex justify-between text-green">
              <a className="py-2" href="/" onClick={this.onLoginClick}>
                Login
              </a>
              <a className="py-2" href="/" onClick={this.onRegisterClick}>
                Registrarme
              </a>
            </div>
            {errorMsg}
          </Form>
        </Modal.Content>
      </Modal>
    )
  }
}

ResetPassword.propTypes = {
  authAction: PropTypes.func.isRequired,
  authResetPassword: PropTypes.func.isRequired,
  authResetPasswordCanceled: PropTypes.func.isRequired,

  error: PropTypes.object,
  onClose: PropTypes.func,
  open: PropTypes.bool,
}

ResetPassword.defaultProps = {
  error: null,
  onClose: Function.prototype,
  open: false,
}

export default connect(({ auth: { error } }) => ({ error }), {
  authAction,
  authResetPassword,
  authResetPasswordCanceled,
})(ResetPassword)
